	export class PottyNotesGestureController {
	
	// Adjust these values as needed
	private static timeSensitivity: number = 300;

	// The lower the number, the less sensitive the swipe is.
	private static deltaYSensitivity: number = 100;
	private static deltaXSensitivity: number = 30;

	private static lastSwipeTime: number = 0;
	private static swipeCooldown: number = 500;

	public static MovedUpEnough(timeDiff: number | null, deltaY: number | null, deltaX: number | null) {
		if (deltaY === null || timeDiff === null || deltaX === null) return false;

		const currentTime = Date.now();
		if (!this.isSwipeAllowed(currentTime)) return false;

		// deltaY > 0 means we swiped down
		if (deltaY > 0) return false;

		if (Math.abs(deltaY) < Math.abs(deltaX)) return false;

		if (deltaY > -this.deltaYSensitivity && timeDiff < this.timeSensitivity) {
				this.lastSwipeTime = currentTime;
				return true;
			};

		return false;
	}

	public static MovedDownEnough(timeDiff: number | null, deltaY: number | null, deltaX: number | null) {
		if (deltaY === null || timeDiff === null || deltaX === null) return false;

		const currentTime = Date.now();
		if (!this.isSwipeAllowed(currentTime)) return false;

		// DeltaY < 0 means we swiped up.
		if (deltaY < 0) return false;

		if (Math.abs(deltaY) < Math.abs(deltaX)) return false;

		if(deltaY > this.deltaYSensitivity  && timeDiff < this.timeSensitivity) {
				this.lastSwipeTime = currentTime;
				return true;
			}

		return false;
	}

	public static MovedRightEnough(timeDiff: number | null, deltaX: number | null, deltaY: number | null) {
		if (deltaX === null || timeDiff === null || deltaY == null) return false;

		const currentTime = Date.now();
		if (!this.isSwipeAllowed(currentTime)) return false;

		if (Math.abs(deltaY) > Math.abs(deltaX)) return false;

		if (deltaX < 0) return false;

		if (deltaX < this.deltaXSensitivity && timeDiff < this.timeSensitivity) {
				console.log("Moved right enough");
				this.lastSwipeTime = currentTime;
				return true;
		}

		return false;
	}

	public static MovedLeftEnough(timeDiff: number | null, deltaX: number | null, deltaY: number | null) {
		if (deltaX === null || timeDiff === null || deltaY == null) return false;

		const currentTime = Date.now();
		if (!this.isSwipeAllowed(currentTime)) return false;

		if (Math.abs(deltaY) > Math.abs(deltaX)) return false;

		if (deltaX > 0) return false;
		
		if (deltaX > -this.deltaXSensitivity && timeDiff < this.timeSensitivity) {
				console.log("Moved left enough");
				this.lastSwipeTime = currentTime;
				return true;
		}

		return false;
	}

	private static isSwipeAllowed(currentTime: number) {
		// If we arent in the cooldown period, allow the swipe
		return !(currentTime - this.lastSwipeTime < this.swipeCooldown)
	}
}